<template>
    <!--App-->
    <div id="body" class="fade-in">
        <div class="col" style="margin-top: 50px;">
            <!--Container com logo-->

            <div id="blurWallpaper">
            </div>

            <div id="divLogin">
                <h1 style="color: white;">Colab Food</h1>
                <br>

                <div id="logoContainer">
                    <img id="logoApp" src="../../../assets/colab-food/logo.png" alt="logo">
                </div>
        
                <!--Usuário-->
                <div class="input-group mb-3">
                    <span class="input-group-text" id="usuarioInputSpan">
                        <i class="bi bi-person-fill"></i>
                    </span>
                    <input type="text" class="form-control" placeholder="Usuário" 
                    id="usuarioInput" required>
                </div>
        
                <!--Senha-->
                <div class="input-group mb-3">
                    <span class="input-group-text" id="senhaInputSpan">
                        <i class="bi bi-key-fill"></i>
                    </span>
                    <input type="password" class="form-control" placeholder="Senha" 
                    id="senhaInput" required>
                </div>
        
                <!--Checkbox para manter a sessão-->
                
                <!--
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                    <label class="form-check-label" for="flexCheckDefault">
                        Manter sessão
                    </label>
                </div>
                -->
                  
        
                <!--Botões de entrar e registrar-->
                <div class="row"  style="margin-top: 25px;">
                    <button type="button" class="btn btn-success" style="font-size: 20px;"
                    @click="autenticarLogin()">
                        <i class="bi bi-box-arrow-in-right me-2"></i>
                        <b>Entrar</b>
                    </button>
                    
                    <!-- <button type="button" class="btn btn-primary" style="font-size: 20px;"
                    onclick="registrarUsuario()">
                        <b>Registrar</b>
                    </button> -->
                </div>

                <div class="row"  style="margin-top: 10px;">
                    <button type="button" class="btn btn-secondary" style="font-size: 15px;"
                    @click="voltarParaPaginaInicial()">
                        <i class="bi bi-house-fill me-2"></i>
                        <b>Voltar para página inicial</b>
                    </button>
                </div>
            </div>
        </div>

        <!--Luiz Trindade - Footer ou Rodapé-->
        <footer id="footerSite" class="bg-dark text-white text-center py-3 mt-auto">
            <div class="container">
                <p class="mb-0">© 2024 Grupo Colab. Todos os direitos reservados.</p>
                <p><a href="#" class="text-white">Termos de Serviço</a> | <a href="#" class="text-white">Política de
                        Privacidade</a></p>
                <p class="d-none d-sm-block">Siga-nos nas redes sociais!</p>
                <p>Este site utiliza código licenciado sob a <a href="https://mit-license.org/" target="_blank">Licença MIT</a>.</p>
            </div>
        </footer>
    </div>
</template>

<script>
//Importação do utils.js
import * as utils from '../../../utils.js';

export default {

    //Luiz Trindade - Nome do componente
    name: "ColabFoodLogin",

    //Luiz Trindade - Declaração de variáveis
    data() {
        return {
        };
    },

    //Luiz Trindade - Importação de componentes
    components: {
    },

    //Luiz Trindade - Métodos que serão executados antes da aplicação ser criada
    beforeCreate() {
        //Luiz Trindade - Verificar se o usuário está logado
    },
    
    //Luiz Trindade - Métodos que serão executados no início da aplicação
    mounted() {
        utils.loader("start");
        this.verificarSessao();
        utils.loader();
    },

    //Luiz Trindade - Métodos padrões
    methods: {
        verificarSessao() {
            const codigo_usuarioHash = localStorage.getItem("codigo_usuario");

            if (utils.verificarHash(codigo_usuarioHash)) {
                //Luiz Trindade - Fazer uma requisição para verificar a sessão
                this.$http.post(this.$servidorRota+'verificarsessao', {
                    codigo_usuario: codigo_usuarioHash
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    if (response.data == 0) {
                        //Luiz Trindade - Se a sessão for verdadeira, redirecionar para home
                        console.log("Usuário logado, redirecionando para home!");
                        this.$router.push("/services/colab-food/views/home");
                    } else {
                        //Se for um hash, mas o hash não for válido, permanece no login
                        console.log("Não está logado!");
                        utils.informar("Realize o login!");
                    }

                    utils.loader();
                })
                .catch(error => {
                    utils.loader();
                });
            } else {
                //Se não for um hash, permanece na tela de login
                console.log("Não está logado!");
                utils.informar("Realize o login!");
            }
        },

        autenticarLogin() {
            utils.loader("start");

            let     nomeValue           = document.getElementById("usuarioInput").value;
            let     senhaValue          = document.getElementById("senhaInput").value;
            const   codigo_usuarioHash  = utils.gerarHash(nomeValue+senhaValue);
            
            //Luiz Trindade - Requisição de autenticação
            this.$http.post(this.$servidorRota+'autenticar', {
                codigo_usuario: codigo_usuarioHash
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                if (response.data == 0) {
                    console.log("Login!");
                    
                    //Luiz Trindade - Setar o código de usuário para ser o da sessão
                    localStorage.setItem("codigo_usuario", codigo_usuarioHash);
                    
                    //Luiz Trindade - Redirecionando para o home
                    this.$router.push("/services/colab-food/views/home");
                } else {
                    utils.informar("Usuário ou senha inválidos!");
                }

                utils.loader();
            })
            .catch(error => {
                console.error('Erro ao registrar o usuário:', error.response ? error.response.data : error.message);
                utils.loader();
            });
        },

        //Luiz Trindade - Função para voltar para a página inicial
        voltarParaPaginaInicial() {
            this.$router.push("/");
        }
    },

    computed: {
    },

    watch: {
    }
}
</script>

<style scoped>
.fade-in {
    opacity: 0;
    /* Começa invisível */
    animation: fadeIn 2.5s forwards;
    /* Aplica a animação */
}
@keyframes fadeIn {
    to {
        opacity: 1;
        /* Finaliza visível */
    }
}

#body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: auto;
    background-image: url("../../../assets/colab-food/login_background.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
}

#blurWallpaper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 0;
    
    /* background-color: rgba(0, 0, 0, .5);
    backdrop-filter: blur(5px); */
    
    background: linear-gradient(
    rgba(0, 0, 0, 0.6), 
    rgba(0, 0, 0, 1)
  );
}

button {
    margin-top: 10px !important;
}

#logoContainer {
    text-align: center;
    margin-bottom: 30px;
}

#logoApp{
    height: 150px;
    border-radius: 20px;
}

#divLogin {
    background-color: rgba(0, 0, 0, .5);
    backdrop-filter: blur(5px);
    padding: 40px;
    border-radius: 10px;
    box-shadow: 2px 4px 6px rgba(0, 0, 0, .5);
    z-index: 2;
}

#footerSite {
    position: relative;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 1;
    padding-top: 10px;
    padding-bottom: 10px;
    box-shadow: 2 4px 6px rgba(0, 0, 0, .5);
    margin-top: 50px !important;
}
</style>